import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="hero" className="relative bg-[#F7F7F7] min-h-[100dvh] flex items-center">
      <div className="w-full max-w-site mx-auto px-4 sm:px-6 py-20 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">

          {/* Copy */}
          <div
            className="order-1 text-center lg:text-left"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 0.6s ease, transform 0.6s ease',
            }}
          >
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-brand border border-brand-blue/20 bg-white px-3 py-1 rounded-full mb-5 md:mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-brand" />
              Digital Marketing Agency
            </span>

            <h1 className="font-display font-bold text-[2rem] sm:text-4xl lg:text-5xl xl:text-[3.25rem] text-gray-900 leading-[1.12] tracking-tight">
              Helping Businesses Grow Their{' '}
              <span className="text-brand">Online Presence</span>
              {' '}— The Right Way
            </h1>

            <p className="mt-5 text-base sm:text-lg text-gray-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              As your digital marketing partner, we provide focused strategy across SEO, performance marketing, social media, and paid advertising — with transparent reporting every step of the way.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-3">
              <Link
                to="/contact"
                className="btn-primary w-full sm:w-auto text-sm px-7 py-3.5 shadow-md"
              >
                Start a Conversation
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/services"
                className="btn-secondary w-full sm:w-auto text-sm px-7 py-3.5 shadow-sm"
              >
                Explore Our Services
              </Link>
            </div>
          </div>

          {/* Illustration */}
          <div
            className="order-2 flex justify-center lg:justify-end"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(12px)',
              transition: 'opacity 0.6s ease 100ms, transform 0.6s ease 100ms',
            }}
          >
            <img
              src="/hero-visual.png"
              alt="Digital marketing team illustration"
              className="w-full max-w-[280px] sm:max-w-[360px] lg:max-w-[460px] xl:max-w-[500px] h-auto object-contain"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
